import { AccountLock } from "./account.lock.model";

export class Account {

  password:string;
  createDate?: Date;
  roleCodes:string[];
  listLock:AccountLock[];
  accountTypeName:string;
  email: string;
  phoneNumber: string;
  address: string;
  agentName:string;
  agentID?:number;
  status?: number;
  accountLanguage?: number;
  roleMasterID?: number;  
  lastUpdate?: Date;
  fullName:string;
  setting:string;
  balance?:number;
  accountName:string;
  accountID?:number;
  denyIPAddress:string;
  allowIPAddress:string;
  tryCount?:number;
  authType?:number;
  accountType?:number;
  isGenAuth: boolean;
  isAuth: boolean;

  constructor() {}
}
